<main>
    <mat-error *ngIf="['NO_MONEY','SERVICE_NOT_AVAILABLE'].includes(stepToSign.target?.target_status)"
               class="mat-error">
        {{ signFormError|translate }}
    </mat-error>

    <div class="button-group" style="width: 100%; display: flex; justify-content: space-between;">
        <mat-icon style="visibility: hidden;">download</mat-icon>
        <button (click)="signOnOffCreditLetter(!this.stepIsSignedByMember)"
                *ngIf="isMemberSigner"
                [disabled]="
                    CONTRACT_STATUSES_TO_SIGN.includes(contractStatus)===false||
                    formState==='Submitting'||
                    this.stepIsSignedByMember && ['SERVICE_NOT_AVAILABLE'].includes(stepToSign.target?.target_status)
                    || !this.stepIsSignedByMember && ['NO_MONEY','SERVICE_NOT_AVAILABLE'].includes(stepToSign.target?.target_status)
                "
                [matTooltip]="this.stepIsSignedByMember? ('CONTRACTS.BUTTONS.TOOLTIPS.REVOKE_SIGN_CL'|translate) : ('CONTRACTS.BUTTONS.TOOLTIPS.SIGN_CL'|translate)"
                [class.revoke]="this.stepIsSignedByMember"
                class="sign-button"
                data-action="signOnOffCreditLetter"
                mat-flat-button
        >
             <span class="sign-button content" [class.revoke]="this.stepIsSignedByMember">
              <app-component-loading *ngIf="formState==='Submitting'" [size]="'inline'"
                                     [margin]="0"></app-component-loading>
                 {{ this.stepIsSignedByMember ? ('CONTRACTS.BUTTONS.REVOKE_SIGN_CL'|translate) : ('CONTRACTS.BUTTONS.SIGN_CL'|translate) }}
            </span>
        </button>
        <mat-icon (click)="saveToExcelSignatores()" class="export-icon"
                  data-action="saveToExcelSignatores"
                  matTooltip="{{'BUTTON_TEXT.TOOLTIPS.EXCEL_EXPORT'|translate}}">
            cloud_download
        </mat-icon>
    </div>
    <mat-list style="width: 100%">
        <mat-list-item *ngFor="let signator of signatories">
            <div [style.color]="signator.sign_data? 'var(--primaryColor)' : 'var(--greyColor)' " class="sign-item">
                <label [matTooltip]="signator.member.email" style="width: 15%;">{{ signator.full_name }}</label>
                <div class="approved" style="display: flex; gap: 1vw;">
                    <mat-icon *ngIf="signator.sign_data" style="margin-bottom: 2px;">done_all</mat-icon>
                    <label [style.color]="signator.sign_data? 'var(--primaryColor)' : 'var(--greyColor)' "
                           class="sign-item__verified-toggle__label"
                    >{{ signator.sign_data ? ('CONTRACTS.FIELDS.APPROVED'|translate) : ('CONTRACTS.FIELDS.PENDING'|translate) }}
                    </label>
                </div>
                <label *ngIf="signator.sign_data" [style.color]=" 'var(--primaryColor)' "
                       class="sign-item__verified-toggle__label"
                >{{ signator.sign_data.created_at | date:'dd/MM/yy, HH:mm:ss' }}
                </label>
                <mat-icon (click)="sentNotification(signator)" *ngIf="!signator.sign_data"
                          [matTooltip]="'CONTRACTS.BUTTONS.TOOLTIPS.REMIND'|translate"
                          data-action="sentNotification"
                          style="color: var(--primaryColor); cursor: pointer;">
                    email
                </mat-icon>
            </div>
        </mat-list-item>
    </mat-list>
</main>
<small class="disabled-button-info" *ngIf="CONTRACT_STATUSES_TO_SIGN.includes(contractStatus)===false"
       style="font-family: Onest;">
    *{{ 'CONTRACTS.BUTTONS.TOOLTIPS.STATUSES_TO_SIGN'|translate }}
    <small *ngFor="let status of CONTRACT_STATUSES_TO_SIGN">
        {{ 'CONTRACTS.STATUSES.' + status|translate|lowercase }}
    </small>
</small>
